import MoeinSideItem from "./MoeinSideItem";
import { useState, useContext } from "react";
import { SetPrintDataContext } from "../../Pages";
import { useNavigate } from "react-router-dom";
import axios from "axios";
const TotalSideItem = ({ data }) => {
  const [isTreesOpen, setIsTreesOpen] = useState(false);
  const setBill = useContext(SetPrintDataContext);

  const navigate = useNavigate();
  function sideBill(e) {
    axios({
      method: "GET",
      url: `${localStorage.getItem("apiUrl2")}w/trd/`,
      params: {
        id: e.target.id,
        level: e.target.dataset.level,
      },
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then((response) => {
      setBill(response.data);
      navigate("/assistant/bill");
    });
  }
  return (
    <li key={data.id}>
      <span>
        <span
          onClick={() => {
            setIsTreesOpen(!isTreesOpen);
          }}
        >
          +
        </span>

        <span className="nude-menu">
          <span id={data.id} data-level={data.level} onClick={sideBill}>
            {data.name}
          </span>
        </span>
        {isTreesOpen && (
          <ul className="sub-main-menu">
            {data.subMenu !== [] &&
              data.subMenu.map((d) => {
                return <MoeinSideItem key={d.id} data={d} />;
              })}
          </ul>
        )}
      </span>
    </li>
  );
};
export default TotalSideItem;
